import { updateContentMargin, modifyFeatureLineup, headerSearchBarFix } from './utils/helpers';
import { updateMenuButton, setNavItemAttributes } from './utils/handleNavigation';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  headerSearchBarFix('Search website...');
  updateMenuButton();
  modifyFeatureLineup();

  $(globalThis).on('load', function () {
    updateContentMargin();
    setNavItemAttributes();
  });
});
